
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function AdminDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    setIsLoading(true);
    try {
      await supabase.auth.signOut();
      navigate("/admin");
    } catch (error) {
      console.error("Error signing out:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold">Vintage Coach Bag CMS</h1>
          <Button
            variant="outline"
            onClick={handleSignOut}
            disabled={isLoading}
          >
            {isLoading ? "Signing out..." : "Sign out"}
          </Button>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="p-6 border rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold mb-4">Manage Bags</h2>
            <p className="text-muted-foreground mb-4">
              Add, edit, or remove bags from the database
            </p>
            <Button onClick={() => navigate("/admin/bags")}>
              Manage Bags
            </Button>
          </div>
          
          <div className="p-6 border rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold mb-4">Manage Catalogs</h2>
            <p className="text-muted-foreground mb-4">
              Upload and organize catalog pages
            </p>
            <Button onClick={() => navigate("/admin/catalogs")}>
              Manage Catalogs
            </Button>
          </div>

          <div className="p-6 border rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold mb-4">Upload Images</h2>
            <p className="text-muted-foreground mb-4">
              Upload and manage bag images
            </p>
            <Button onClick={() => navigate("/admin/images")}>
              Manage Images
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
